import { createUseStyles } from 'react-jss'
import { zIndexes } from '../../variables.style'

export const style = {
  sideBySideChartContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    maxWidth: 1022,
    width: '100%',
    margin: '0 auto',
    '& > *:first-child': {
      zIndex: zIndexes.sideBySideChartLeft
    },
    '& > *:last-child': {
      zIndex: zIndexes.sideBySideChartRight
    }
  }
}

export const useStyles = createUseStyles(style)
